<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <button-add :pathName="addMonthlyVehicle" v-if="permissionCodes.indexOf('004008003') !== -1"></button-add>
        <button-upload
          :cathUrl="uploadUrl"
          :onSuccess="onUploadSuccess"
          @getpage="getPage"
          v-if="permissionCodes.indexOf('004008001') !== -1"
          value="导入"/>
        <button-export
          :href="exportUrl"
          :beforeDownload="beforeDownload"
          v-if="permissionCodes.indexOf('004008002') !== -1"
          download="download.xls"
          value="导出"/>
      </div>
      <input-search placeholder="车牌号/副车车牌号/车主姓名" @search="searchKey" />
    </div>
    <div class="search-line">
      <div class="btn-box">
        <span style="display: inline-block;color: #48576a;font-size: 14px;line-height: 30px;margin-right: 5px;">截止时间</span>
        <el-date-picker v-model="timevalue"  size="small" type="daterange" style="width: 280px;" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期"
                        align="right" value-format="yyyy-MM-dd">
        </el-date-picker>
      </div>
      <div class="btn-box">
        <input-select selectTitle="是否一人多车" :selectKey="'isHaveOther'" :selectData="isHaveOtherList" @search="search" style="margin-right: 10px"/>
      </div>
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" :total="total" :pageNum="pageNum" :pageSize="pageSize" @refund="toRefundPage" @renew="toRenewPage" @toCurrentPage="toCurrentPage" @deleteLine="deleteLine" @goToModifyPage="goToModifyPage"  @changePagination="changePagination" tableOperationWidth="220" :operationArr="operationArr"  />
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonAdd from "../../../components/Button/ButtonAdd";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/ParkingService";
import { errorHandler } from "../../../utils/errorHandler";
import { nAlert, nSuccess } from "../../../utils/notice";
import { bus } from "../../../utils/bus";

export default {
  components: {
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    Breadcrumb
  },
  name: "monthly-vehicle",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "智慧停车",
          name: "parking-device-management"
        },
        {
          value: "包月车辆"
        }
      ],
      addController: "authorization-add",
      addMonthlyVehicle: "monthly-vehicle-add",
      exportUrl: "",
      uploadUrl: "",
      isHaveOtherList: [
        { key: "", label: "全部" },
        { key: "1", label: "是" },
        { key: "0", label: "否" }
      ],
      tableHead: [
        {
          prop: "carNumber",
          label: "车牌号",
          width: 120
        },
        {
          prop: "isHaveOtherText",
          label: "是否一人多车",
          width: 120
        },
        {
          prop: "otherCarNumber",
          label: "副车车牌号",
          width: 180
        },
        {
          prop: "carOwnerName",
          label: "车主姓名",
          width: 120
        },
        {
          prop: "enterpriseName",
          label: "所属企业",
          width: 240
        },
        {
          prop: "carOwnerPhone",
          label: "手机号",
          width: 120
        },
        {
          prop: "paymentMethodText",
          label: "缴费方式"
        },
        {
          prop: "enterStartDate",
          label: "起始日期",
          width: 120
        },
        {
          prop: "enterEndDate",
          label: "截止日期",
          width: 120
        },
        {
          prop: "lotNumber",
          label: "车位号",
          width: 120
        },
        {
          prop: "bindTypeText",
          label: "绑定类型",
          width: 120
        },
        {
          prop: "authorizationTime",
          label: "绑定时间",
          width: "180"
        },
        {
          prop: "operator",
          label: "操作人"
        },
        {
          prop: "statusText",
          label: "状态",
        },
        {
          prop: "memo",
          label: "备注",
          width: 120
        }
      ],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      selectionArr: [],
      requestData: {
        searchKey: "",
        isHaveOther: "",
        startTime: "",
        endTime: ""
      },
      // operationArr: ["renew", "refund"],
      operationArr: ["modify", "renew", "refund", "delete"],
      timevalue: []
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.uploadUrl = api.importParkingMonthCarManagerPage;
    // this.exportUrl = `${api.exportAuthority}?yq-app-code=${bus.global.yqCode}&kj-type=gy`
    this.getPage();
  },
  activated() {
    this.getPage();
  },
  methods: {
    beforeDownload() {
      this.exportUrl = `${api.exportParkingMonthCarManagerPage}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${
        this.requestData.searchKey
      }&startTime=${this.requestData.startTime}&endTime=${
        this.requestData.endTime
      }&isHaveOther=${this.requestData.isHaveOther}`;
    },
    // 获取授权分页
    getPage() {
      if (this.timevalue) {
        this.requestData.startTime = this.timevalue[0] || "";
        this.requestData.endTime = this.timevalue[1] || "";
      } else {
        this.requestData.startTime = "";
        this.requestData.endTime = "";
      }
      let reqData = this.requestData;
      reqData.pageNum = this.pageNum;
      reqData.pageSize = this.pageSize;
      this.$axios
        .post(api.getParkingMonthCarManagerPage, reqData)
        .then(res => {
          console.log(res);
          let data = res.data.data.list;
          data.map(v => {
            v.isHaveOtherText = v.isHaveOther === "1" ? "是" : "否";
            if (v.bindType === "1") {
              v.bindTypeText = "管理员绑定";
            } else if (v.bindType === "2") {
              v.bindTypeText = "个人绑定";
            }
            if (v.enterStartTime && v.enterEndTime) {
              v.enterStartTime = v.enterStartTime.slice(0, 11);
              v.enterEndTime = v.enterEndTime.slice(0, 11);
              v.termOfValidity = `${v.enterStartTime}至${v.enterEndTime}`;
            } else {
              v.termOfValidity = "--";
            }
            if (v.paymentMethod == "1") {
              v.paymentMethodText = "月缴";
            } else if (v.paymentMethod == "2") {
              v.paymentMethodText = "季缴";
            } else if (v.paymentMethod == "3") {
              v.paymentMethodText = "半年缴";
            } else if (v.paymentMethod == "4") {
              v.paymentMethodText = "年缴";
            }
            if(v.status=='1'){
              v.statusText ='审批中'
            }else if(v.status=='2'){
              v.statusText ='驳回'
            }else if(v.status=='3'){
              v.statusText ='通过'
            }else if(v.status=='4'){
              v.statusText ='撤回'
            }
          });
          this.total = res.data.data.total;
          this.tableData = data;
        })
        .catch(errorHandler("获取数据失败"));
    },
    search(v) {
      this.pageNum = 1;
      this.requestData[v.key] = v.value;
      this.getPage();
    },
    searchKey(v) {
      this.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    },
    onUploadSuccess(data) {
      if (data.retCode == 1) {
        nSuccess("导入成功");
        this.pageSize = 10;
        this.pageNum = 1;
        this.getPage();
      } else {
        errorHandler("导入失败")(data);
      }
    },
    toCurrentPage(code) {
      this.$router.push({
        path: `/park_server/authorization_current/${code}`
      });
    },
    deleteLine(code) {
      this.$axios
        .post(api.deleteByManager, code)
        .then(res => {
          nSuccess("删除成功");
          this.getPage();
        })
        .catch(errorHandler("删除失败"));
    },
    goToModifyPage(code) {
      this.$router.push({
        path: `/park_server/monthly_vehicle_modify/${code}`
      });
    },
    toRefundPage(code) {
      this.$router.push({
        path: `/park_server/monthly_vehicle_refund/${code}`
      });
    },
    toRenewPage(code) {
      this.$router.push({
        path: `/park_server/monthly_vehicle_renew/${code}`
      });
    }
  },
  watch: {
    timevalue(val) {
      this.getPage();
    }
  }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>

<style lang="less">
.el-input--small .el-input__inner {
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/MonthlyVehicle/MonthlyVehicle.vue